// extracted by mini-css-extract-plugin
module.exports = {"Favorites":"Favorites__Favorites__3A5-0","Icon":"Favorites__Icon__1SDIf","Items":"Favorites__Items__3bu3Y"};